import transport from './transport'

export default angular.module('control.common', [
    transport
]).name